import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImageSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImageSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM5 5V13.5858L8 10.5858L16.4142 19H19V5H5Z" fill="currentColor"/><Path d="M13.5 8.5L14.5 6.5L15.5 8.5L17.5 9.5L15.5 10.5L14.5 12.5L13.5 10.5L11.5 9.5L13.5 8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImageSparkle;
